import { gql } from "@apollo/client";

export const getRemoteAssetsQuota = gql`
    query getRemoteAssetsQuota($organizationId: ID!) {
        remoteAssetsQuota(input: { organizationId: $organizationId }) {
            usedBytes
            totalBytes
            perAssetLimitBytes
            perLensLimitBytes
        }
    }
`;
